import React, {Component} from 'react';
import './index.scss';
import {FormattedMessage} from 'react-intl';
import SearchBar from '@stubhub/react-search-component';
import SellSearchCarousel from '../react-sell-carousel';

class SellSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      hasBeenNotified: false
    };
  }

  notifySell = ({isSearchActive = false}) => {
    const {hasBeenNotified} = this.state;
    if (!hasBeenNotified) {
      this.setState({
        hasBeenNotified: true
      });
    } else {
      this.setState({
        showOverlay: isSearchActive
      });
    }
  };

  render() {
    const {showOverlay} = this.state;
    const {deviceType, onModalSearchActiveChanged} = this.props;
    return (
      <>
        <div className="SellSearch__banner">
          <SellSearchCarousel deviceType={deviceType} />
          <div className={'SellSearch__overlay ' + (showOverlay ? 'SellSearch__showSellOverlay' : '')}></div>
          <div className="SellSearch__container">
            <div className="SellSearch__msgContainer">
              <div className="SellSearch_bannerMsg">
                <FormattedMessage id="SellSearch.Banner.msg1" defaultMessage="Plans Changed?" />
              </div>
              <FormattedMessage id="SellSearch.Banner.msg2" defaultMessage="Sell your tickets now">
                {(txt) => <h1 className="SellSearch_bannerMsg msg2">{txt}</h1>}
              </FormattedMessage>
            </div>
            <SearchBar
              searchStyle={'expanded'}
              onModalSearchActiveChanged={onModalSearchActiveChanged}
              suggestVariant={7}
              merchClassName={'MerchHeader sellSearch'}
              app={'sell'}
              notifySell={this.notifySell}
              isSearchAutoFocus
            />
          </div>
        </div>
      </>
    );
  }
}

export default SellSearch;
